import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditSparePart() {
  const { id } = useParams();
  const [machines, setMachines] = useState([]);
  const [data, setData] = useState({
    machine_id: "",
    part_name: "",
    quantity: ""
  });

  useEffect(() => {
    fetchPart();
    fetchMachines();
  }, []);

  const fetchPart = () => {
    axios.get(baseUrl + "spare-parts/" + id + "/")
      .then(res => setData({
        machine_id: res.data.machine?.id || "",
        part_name: res.data.part_name,
        quantity: res.data.quantity
      }))
      .catch(() => Swal.fire("Error", "Could not fetch spare part", "error"));
  };

  const fetchMachines = () => {
    axios.get(baseUrl + "machines/").then(res => setMachines(res.data));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {
    const _formData = new FormData();
    _formData.append("machine", data.machine_id);
    _formData.append("part_name", data.part_name);
    _formData.append("quantity", data.quantity);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "spare-parts/" + id + "/", _formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then(() => Swal.fire({ title: "Updated", icon: "success", timer: 2000, showConfirmButton: false }))
      .then(() => window.location.href = "/spare-part/")
      .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Spare Part</h4>

        <select name="machine_id" value={data.machine_id} onChange={inputHandler} className="form-control mt-3">
          <option value="">Select Machine</option>
          {machines.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>

        <input type="text" className="form-control mt-3" placeholder="Part Name" name="part_name" value={data.part_name} onChange={inputHandler} />
        <input type="number" className="form-control mt-3" placeholder="Quantity" name="quantity" value={data.quantity} onChange={inputHandler} />

        <button className="btn btn-primary mt-3" onClick={formSubmit}>Update</button>
      </div>
    </div>
  );
}

export default EditSparePart;
